import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PrintIcon from '@material-ui/icons/Print';
import * as fmt from '../utils/fmt';

import { roles } from '../services/user';

export default function QueryDialog({
  queryId,
  limitDate,
  close = Function.prototype,
  ...rest
}) {

  const redirectToPrint = () => window.location = `/consulta/${queryId}`;
  return <Dialog {...rest}>
    <DialogTitle>Consulta Ainda Válida</DialogTitle>
    <DialogContent>
      <DialogContentText>{`A consulta ${queryId} possui cadastro válido
            até ${fmt.isoDate(limitDate)}.
            Não é possível efetuar esse processo neste momento`}
      </DialogContentText>
    </DialogContent>

    <DialogActions>
      { roles('profile.report') &&
       <Button color="primary" onClick={redirectToPrint}>
         <PrintIcon style={{color: 'rgba(0, 0, 0, 0.54)'}}/>
       </Button>
      }
      <Button color="primary" onClick={close} autoFocus>
        Ok
      </Button>

    </DialogActions>

  </Dialog>;
}
